import { DURATION_OPTIONS } from './constants.js';

// Formats hour number (0..24) to string like "9 am", "12 pm", "8 pm"
export function formatHourLabel(h) {
  if (h === 0 || h === 24) return '12 am';
  if (h < 12) return `${h} am`;
  if (h === 12) return '12 pm';
  return `${h - 12} pm`;
}

function formatMinutes(total) {
  const h = Math.floor(total / 60);
  const m = total % 60;
  const period = h < 12 || h === 24 ? 'am' : 'pm';
  const displayH = h === 0 || h === 24 ? 12 : h > 12 ? h - 12 : h;
  return `${displayH}:${String(m).padStart(2, '0')} ${period}`;
}

// Back-to-back slots of `duration` minutes between startHour and endHour.
// The key is the slot's start time (HH:MM), so grids stay addressable per duration.
export function generateTimeSlots(startHour, endHour, duration = 30) {
  const s = Math.max(0, Math.min(23, Number.isFinite(Number(startHour)) ? Number(startHour) : 9));
  const e = Math.max(s + 1, Math.min(24, Number(endHour) || 20));
  const step = DURATION_OPTIONS.includes(Number(duration)) ? Number(duration) : 30;

  const slots = [];
  for (let t = s * 60; t + step <= e * 60; t += step) {
    const hour = Math.floor(t / 60);
    const minute = t % 60;
    slots.push({
      key: `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`,
      label: `${formatMinutes(t)} - ${formatMinutes(t + step)}`,
      hour,
      minute,
      startMinutes: t,
    });
  }
  return slots;
}

// Default availability: every slot starting between 2 PM and 8 PM is checked.
export function buildDefaultGrid(days, slots) {
  const grid = {};
  for (const day of days) {
    for (const slot of slots) {
      if (slot.startMinutes >= 14 * 60 && slot.startMinutes < 20 * 60) {
        grid[`${day}_${slot.key}`] = true;
      }
    }
  }
  return grid;
}
